import { useEffect, useRef } from 'react'
import { useDataLayerAction } from '@corratech/pylot-tag-manager'
import type { CategoryTree, ProductInterface, Maybe } from '@pylot/pylotschema'

export const usePLPAnalytics = (
    category: Maybe<CategoryTree> | undefined,
    productsToRender: Maybe<ProductInterface>[]
) => {
    const dataLayerActionRef = useRef(true)
    const dataLayerAction = useDataLayerAction()

    useEffect(() => {
        if (!(
            productsToRender?.length &&
            category?.name &&
            dataLayerActionRef.current
        ))
            return

        const products = productsToRender.map((p) => ({
            ...p,
            price: p?.price_range?.minimum_price?.final_price?.value || 0,
            currencyCode:
                p?.price_range?.minimum_price?.final_price?.currency || '-'
        }))

        dataLayerAction({
            type: 'PLP',
            data: {
                type: 'ProductsImpressions',
                category: { name: category.name },
                currencyCode:
                    productsToRender[0]?.price_range?.minimum_price?.final_price
                        ?.currency || '-',
                productsDetails: [...products],
                products: { items: [...products] }
            }
        })

        dataLayerActionRef.current = false
    }, [dataLayerAction, category?.name, productsToRender])
}
